class ToastService {
    private _listeners = new Set<(event: { message: string; type: string }) => void>();

    constructor() {}

    show(message: string, type = 'error') {
        this._listeners.forEach(fn => fn({ message, type }));
    }

    subscribe(listener: (event: { message: string; type: string }) => void) {
        this._listeners.add(listener);
        return () => this._listeners.delete(listener);
    }
}

export const toastService = new ToastService();